import {
  AboutCompanySection,
  AboutCompanyTwoSection,
  ApplicationFormSection,
  CompanyPartnersSection,
  HeroSection,
  ProjectsSection,
  ServicesSection,
} from "../sections";

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <AboutCompanySection />
      <AboutCompanyTwoSection />
      <CompanyPartnersSection />
      <ServicesSection />
      <ProjectsSection />
      <ApplicationFormSection />
    </>
  );
};

export default HomePage;

